import * as React from "react";
import styled from "styled-components";

import { media } from "../../common/utils/style";
import Translate from "../../common/components/Translate";
import Carousel from "../../common/components/Carousel";
import CompanyCard, { CompanyCardModels } from "./CompanyCard";
import CompanyCardLateral, { CompanyCardLateralModels } from "./CompanyCardLateral";
import { SectionInner, SectionTitle } from "./Section";
import WithScreenSize from "../../common/components/WithScreenSize";

type Company = WtdModels.UnionAll<
  WtdModels.Partial<WtdModels.Company, "id">,
  CompanyCardModels["Company"],
  CompanyCardLateralModels["Company"]
>;

export interface SimilarCompaniesSectionModels {
  Company: Company;
}

interface Props {
  companies: Company[];
}

const SimilarCompaniesSection: React.SFC<Props> = props => {
  const { companies } = props;
  if (companies.length <= 0) {
    return null;
  }

  return (
    <Section>
      <SectionInner>
        <SectionTitle>
          <Translate id="company.similar_companies" />
        </SectionTitle>
      </SectionInner>
      <WithScreenSize>
        {({ screenSize }) => (
          <SectionInner>
            {screenSize === "small" ? (
              companies.map(company => <CompanyCardMobile key={company.id} company={company} />)
            ) : (
              <Carousel
                layouts={{
                  small: { perPage: 1.5, gutter: 16 },
                  medium: { perPage: 2.3, gutter: 16 },
                  large: { perPage: 2.82, gutter: 24 },
                }}
                childCount={companies.length}
                renderChild={(index, isActive) => {
                  const company = companies[index];
                  return <CompanyCard key={company.id} company={company} floatsByHover={isActive} />;
                }}
              />
            )}
          </SectionInner>
        )}
      </WithScreenSize>
    </Section>
  );
};

const Section = styled.section`
  padding: 60px 0 40px;
  background-color: #fafafa;
  overflow: hidden;
  @media ${media.large} {
    padding: 60px 0 88px;
  }
`;

const CompanyCardMobile = styled(CompanyCardLateral)`
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export default SimilarCompaniesSection;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/SimilarCompaniesSection.tsx